'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.weekly_group_report', {
        template: '<weekly-group-report></weekly-group-report>'
    });
}



// WEBPACK FOOTER //
// ./public/dev/app/group_report/weekly/weekly_group_report.routes.js